import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationAR from "./messages/ar.json";
import translationEN from "./messages/en.json";
import translationTR from "./messages/tr.json";

// The translations
const resources = {
    ar: {
        translation: translationAR,
    },
    en: {
        translation: translationEN,
    },
    tr: {
        translation: translationTR,
    },
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "ar", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        fallbackLng: "en",
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

// Logic to change direction based on language
i18n.on('languageChanged', (lng) => {
    document.dir = lng === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
});

// Initial direction setup
document.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
document.documentElement.lang = i18n.language;

export default i18n;
